import React from 'react';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const NotSent = 'NotSent';

const shipmentNotificationToState = {
  [NotSent]: 'empty',
  Sent: 'normal',
  Error: 'error',
};

const ShipmentNotificationColumn = ({ fulfillmentId }) => {
  const { shipmentEmailNotification } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { status, errorMessage } = shipmentEmailNotification ?? {};

  const shipmentNotification = status ?? NotSent;
  const tooltipMessage = errorMessage ?? <FormattedMessage {...messages.shipmentNotification} />;
  return (
    <IconMessageColumn
      icon={faPaperPlane}
      message={<FormattedMessage {...messages.sent} />}
      popoverFlyoutTitle={<FormattedMessage {...messages.shipmentNotificationTooltipTitle} />}
      state={shipmentNotificationToState[shipmentNotification]}
      tooltipMessage={tooltipMessage}
    />
  );
};

ShipmentNotificationColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const ShipmentNotification = {
  getMessageDescriptor: () => messages.shipmentNotification,
  id: 'shipment-email-notified',

  render: (data) => {
    return <ShipmentNotificationColumn fulfillmentId={data.id} />;
  },
};
